module.exports = { "default": require("core-js/library/fn/set"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.25.0@babel-runtime/core-js/set.js
// module id = 144
// module chunks = 20